<template>
  <div>
    <!-- Tabs for Crew Combinations -->
    <v-tabs
      v-model="activeTab"
      show-arrows
      grow
      background-color="transparent"
      color="primary"
      slider-color="primary"
      height="36"
      class="mb-2"
    >
      <v-tab
        v-for="crewCombination in crewCombinations"
        :key="crewCombination.id"
        small
        class="text-none"
      >
        <v-icon
          left
          small
          :color="getStatusIconColor(crewCombination.fulfillmentStatus.status)"
        >
          {{ getStatusIcon(crewCombination.fulfillmentStatus.status) }}
        </v-icon>
        {{ crewCombination.title }}
      </v-tab>
    </v-tabs>

    <!-- Tab Content -->
    <v-tabs-items v-model="activeTab" class="transparent">
      <v-tab-item
        v-for="crewCombination in crewCombinations"
        :key="crewCombination.id"
      >
        <v-card-text class="py-0">
          <!-- Personnel Utilization Summary -->
          <personnel-utilization-summary
            v-if="
              crewCombination.fulfillmentStatus.remainingPersonnel !== undefined
            "
            :fulfillment-status="crewCombination.fulfillmentStatus"
            class="mb-3"
          />

          <!-- Position Assignments Table -->
          <position-assignments-table
            v-if="crewCombination.fulfillmentStatus.positionDetails"
            :position-details="
              crewCombination.fulfillmentStatus.positionDetails
            "
            class="mb-3"
          />

          <!-- Improvement Suggestions -->
          <suggestions-alert
            v-if="showSuggestions"
            :suggestions="crewCombination.fulfillmentStatus.suggestions"
            @suggestion-action="$emit('suggestion-action', $event)"
          />
        </v-card-text>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import PersonnelUtilizationSummary from "./PersonnelUtilizationSummary.vue";
import PositionAssignmentsTable from "./PositionAssignmentsTable.vue";
import SuggestionsAlert from "./SuggestionsAlert.vue";
import { getStatusIcon, getStatusIconColor } from "@/util/statusUtils";

export default {
  name: "CrewCombinationDetails",
  components: {
    PersonnelUtilizationSummary,
    PositionAssignmentsTable,
    SuggestionsAlert,
  },
  props: {
    crewCombinations: {
      type: Array,
      required: true,
    },
    showSuggestions: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      activeTab: 0,
    };
  },
  computed: {
    defaultTab() {
      // Prioritize the best option
      const bestOptionIndex = this.crewCombinations?.findIndex(
        (cc) => cc.isBestOption
      );
      if (bestOptionIndex >= 0) return bestOptionIndex;

      // Otherwise, find the selected crew combination
      const selectedIndex = this.crewCombinations?.findIndex(
        (cc) => cc.isSelected
      );
      return selectedIndex >= 0 ? selectedIndex : 0;
    },
  },
  watch: {
    defaultTab: {
      immediate: true,
      handler(newVal) {
        this.activeTab = newVal;
      },
    },
  },
  methods: {
    getStatusIcon,
    getStatusIconColor,
  },
};
</script>

<style scoped>
.v-tabs-items {
  background-color: transparent !important;
}

.v-tab-item {
  padding: 0 !important;
}
</style>
